import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { BudgetAssignmentsModule } from '@features/budget-assignments/budget-assignments.module';
import { FundingSourceModule } from '@features/funding-sources/funding-source.module';
import { RuleAutomationModule } from '@features/rule-automation/rule-automation.module';
import { SystemTagsModule } from '@features/system-tags/system-tags.module';
import { FlyoutModule } from '@yourcause/common/flyout';
import { BudgetAddInKindItemComponent } from './budget-add-in-kind-item/budget-add-in-kind-item.component';
import { BudgetAuditTrailTabComponent } from './budget-audit-trail-tab/budget-audit-trail-tab.component';
import { BudgetAuditTrailTableComponent } from './budget-audit-trail-table/budget-audit-trail-table.component';
import { BudgetDetailFlyoutComponent } from './budget-detail-flyout/budget-detail-flyout.component';
import { BudgetDetailPageComponent } from './budget-detail-page/budget-detail-page.component';
import { BudgetFundingSourceModalComponent } from './budget-funding-source-modal/budget-funding-source-modal.component';
import { BudgetFundingSourcesTabComponent } from './budget-funding-sources-tab/budget-funding-sources-tab.component';
import { BudgetImportModalComponent } from './budget-import-modal/budget-import-modal.component';
import { BudgetsPageComponent } from './budgets-page/budgets-page.component';
import { BudgetsWrapperComponent } from './budgets-wrapper/budgets-wrapper.component';
import { BulkBudgetManagementModalComponent } from './bulk-budget-management-modal/bulk-budget-management-modal.component';
import { CreateEditBudgetModalComponent } from './create-edit-budget-modal/create-edit-budget-modal.component';
import { OpenCloseBudgetModalComponent } from './open-close-budget-modal/open-close-budget-modal.component';
import { SumTotalAvailablePipe } from './pipes/sum-total-available.pipe';

@NgModule({
  imports: [
    GCCoreModule,
    BudgetAssignmentsModule,
    RuleAutomationModule,
    FundingSourceModule,
    SystemTagsModule,
    FlyoutModule
  ],
  declarations: [
    BudgetsWrapperComponent,
    BudgetsPageComponent,
    BudgetDetailPageComponent,
    BudgetFundingSourceModalComponent,
    OpenCloseBudgetModalComponent,
    BudgetFundingSourcesTabComponent,
    BudgetAuditTrailTabComponent,
    BudgetImportModalComponent,
    CreateEditBudgetModalComponent,
    BudgetAddInKindItemComponent,
    SumTotalAvailablePipe,
    BulkBudgetManagementModalComponent,
    BudgetDetailFlyoutComponent,
    BudgetAuditTrailTableComponent
  ],
  exports: [
    CreateEditBudgetModalComponent,
    BudgetAddInKindItemComponent,
    SumTotalAvailablePipe
  ]
})
export class BudgetsModule { }
